import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'

const app = createApp(App)
app.use(router)
// app.config.errorHandler = (err, vm, info) => {
//   console.error('Global error:', err, info);
// }
app.mount('#app')
